import React from 'react';

interface ClaimOverviewCardProps {
  createdAt: string;
  completedAt?: string;
  eventType?: string;
  coverageYear?: number;
}

export const ClaimOverviewCard: React.FC<ClaimOverviewCardProps> = ({
  createdAt,
  completedAt,
  eventType,
  coverageYear,
}) => {
  return (
    <div className="rounded-xl border shadow-sm overflow-hidden" style={{ backgroundColor: 'var(--color-bg-surface)', borderColor: 'var(--color-border)' }}>
      <div className="px-6 py-4 border-b flex items-center justify-between" style={{ borderColor: 'var(--color-border)', backgroundColor: 'var(--color-bg-elevated)' }}>
        <h2 className="font-semibold" style={{ color: 'var(--color-text-primary)' }}>Claim Overview</h2>
        <div className="text-sm" style={{ color: 'var(--color-text-muted)' }}>
          Created {new Date(createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
          {completedAt && ` • Completed ${new Date(completedAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`}
        </div>
      </div>
      <div className="p-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div>
            <p className="text-sm mb-1" style={{ color: 'var(--color-text-muted)' }}>Created</p>
            <p className="font-medium" style={{ color: 'var(--color-text-primary)' }}>{new Date(createdAt).toLocaleString()}</p>
          </div>
          {completedAt && (
            <div>
              <p className="text-sm mb-1" style={{ color: 'var(--color-text-muted)' }}>Completed</p>
              <p className="font-medium" style={{ color: 'var(--color-text-primary)' }}>{new Date(completedAt).toLocaleString()}</p>
            </div>
          )}
          {eventType && (
            <div>
              <p className="text-sm mb-1" style={{ color: 'var(--color-text-muted)' }}>Event Type</p>
              <p className="font-medium capitalize" style={{ color: 'var(--color-text-primary)' }}>{eventType}</p>
            </div>
          )}
          {coverageYear && (
            <div>
              <p className="text-sm mb-1" style={{ color: 'var(--color-text-muted)' }}>Coverage Year</p>
              <p className="font-medium" style={{ color: 'var(--color-text-primary)' }}>{coverageYear}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClaimOverviewCard;
